<template>
  <v-dialog v-model="dialog" width="auto">
    <v-card>
      <v-row class="pa-4 align-center row wrap">
        <v-col cols="12" xs="6" md="6" lg="6">
          <v-text-field
            v-model="quantity"
            :label="$t('parts.insert_parts.empty_parts.quantity')"
            type="number"
            min="1"
            max="100"
          />
        </v-col>
        <v-col cols="12" xs="6" md="6" lg="6">
          <v-row align-center justify-center row wrap>
            <v-btn :loading="loading" color="primary" @click="insert">
              {{ $t("parts.insert_parts.empty_parts.create_parts") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import postRequest from "../../api/postRequest";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    quantity: null,
    shipmentId: null,
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.loading = false;
        this.quantity = null;
        this.shipmentId = null;
      }
    },
  },
  methods: {
    open(shipmentId) {
      this.shipmentId = shipmentId;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.quantity = null;
      this.shipmentId = null;
    },
    insert() {
      if (this.quantity && this.shipmentId) {
        this.loading = true;
        postRequest
          .object(
            `/temporary-part/insert/empty/multiple/${
              this.quantity
            }?user_id=${this.$store.getters.userId}&institution_id=${
              this.$store.getters.institutionId
            }&shipment_id=${this.shipmentId}`,
          )
          .then((response) => {
            if (response) {
              this.$emit("inserted");
              this.close();
            }
          })
          .catch(() => {
            this.close();
          });
      }
    },
  },
};
</script>
